/* Angular Component */
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Tag } from '../../../domain/tag';

@Component({
  selector: 'tags-wrapper',
  templateUrl: './tagsWrapper.component.html',
  styleUrls: ['./tagsWrapper.component.scss'],
})
export class TagsWrapperComponent {
  @Input()
  tags: Tag[] = [];

  @Output()
  onDeleteTag = new EventEmitter<Tag>();

  constructor() {}

  /**
   * Initializing component
   * @return void
   */
  ngOnInit() {}

  /**
   * Removing Tag Handler
   * @param tag
   * @return void
   */
  removeTag(tag: Tag): void {
    this.onDeleteTag.emit(tag);
  }
}
